import { render, staticRenderFns } from "./LeagueSelect.component.vue?vue&type=template&id=5bd4e87a"
import script from "./LeagueSelect.component.vue?vue&type=script&lang=js"
export * from "./LeagueSelect.component.vue?vue&type=script&lang=js"
import style0 from "./LeagueSelect.component.vue?vue&type=style&index=0&id=5bd4e87a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports